module.exports = __webpack_public_path__ + "static/media/cflogo2.d2f256c8.png";